// extracted by mini-css-extract-plugin
module.exports =  {"quick-question":"M4QCT9R","quickQuestion":"M4QCT9R","drawer":"cX2YOiW"};